// extracted by mini-css-extract-plugin
export default {"container":"table-title_container__EKNHS"};